import { h, Component } from "preact";
import { msg } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";
import MobilePage from "../../utils/mobile-page";

import { CloseIconSlim } from "../../mobile-templates/general";
import VisibleOnHash from "../../utils/hash-popup";
import { FormRow, HorizontalInputs, Input, InputLabel, SmallInput } from "../../desktop-components/user/login-popup";
import User from "../../../../services/user";

import AwrabetPopupRecovery, {
    RecoveryForm as AwrabetRecoveryForm
} from "../../../awrabet/mobile-components/site/popup-recovery";

export default class PopupRecovery extends AwrabetPopupRecovery {
    render() {
        return (
            <VisibleOnHash id="recovery-page" class={"fixed z-10 inset-0 overflow-y-auto text-white backdrop-blur-sm"} hash="#recovery">
                <div class="absolute top-0 right-0 w-12 p-3 fn-close" onClick={e => MobilePage.goBack()}>
                    <CloseIconSlim />
                </div>
                <div class="pl-12 h-full">
                    <div class="flex h-full flex-col bg-blue-whale-800 text-white">
                        <RecoveryForm />
                        <div class="grow"></div>
                        <div class="bg-blue-whale-700 px-2 py-2">
                            <div class="py-1 text-center">
                                <Trans>Create an account</Trans>
                                <a class="border-b border-amber-500 pb-0.5 px-0.5 text-amber-500" href="#register">
                                    <Trans>Register</Trans>
                                </a>
                            </div>
                            <div class="py-1 text-center text-sm"><Trans>Login to place bets</Trans></div>
                        </div>
                    </div>
                </div>
            </VisibleOnHash>
        );
    }
}



export class RecoveryForm extends AwrabetRecoveryForm {
    stepOneForm() {
        return <form ref={ref => this.form = ref} onSubmit={e => this.stepOneSubmit(e)}>
            <FormRow>
                <InputLabel>Phone Number</InputLabel>
                <HorizontalInputs>
                    <SmallInput value="ET +251" disabled={true} autocomplete="tel-country-code" class="w-20 bg-slate-200 text-slate-500 border-slate-300" />
                    <Input class="grow" name="username" required={true} autocomplete="tel-national" onInput={e => this.setState({ username: e.target.value })} value={this.state.username || ''} />
                </HorizontalInputs>
            </FormRow>

            <div class="w-full px-2 text-center pt-3 mt-2">
                <button type="submit" class="w-full bg-amber-400 text-amber-950 py-2 text-center text-base font-bold uppercase hover:bg-amber-600">
                    {this.state.username ? <Trans>Reset Password</Trans> : <Trans>Send SMS OTP</Trans>}
                </button>
            </div>
        </form>;
    }

    stepTwoForm() {
        return <form ref={ref => this.form = ref} onSubmit={e => this.stepTwoSubmit(e)}>
            {this.state.username && <div class="text-sm text-slate-100 py-2"><Trans>We have sent you an SMS with a security code. Please enter it below to reset your password.</Trans></div>}
            
            <FormRow>
            <InputLabel>OTP Code</InputLabel>
            <HorizontalInputs>
                <Input class="grow" name="otp" required={true} />
            </HorizontalInputs>
            </FormRow>

            <div class="w-full px-2 text-center pt-3 mt-2">
            <button type="submit" class="w-full bg-amber-400 text-amber-950 py-2 text-center text-base font-bold uppercase hover:bg-amber-600">
                <Trans>Check OTP</Trans>
            </button>
            </div>
        </form>;
    }

    stepThreeForm() {
        return <form ref={ref => this.form = ref} onSubmit={e => this.stepThreeSubmit(e)}>
            <FormRow>
                <InputLabel>Password</InputLabel>
                <Input placeholder={window.Translation(msg`Password`)} class="grow" type="password" name="password" required={true} autocomplete="new-password" />
            </FormRow>
            <FormRow>
                <InputLabel>Repeat Password</InputLabel>
                <Input placeholder={window.Translation(msg`Repeat Password`)} class="grow" type="password" name="confirmPassword" required={true} autocomplete="new-password" />
            </FormRow>

            <div class="w-full px-2 text-center pt-3 mt-2">
                <button type="submit" class="w-full bg-amber-400 text-amber-950 py-2 text-center text-base font-bold uppercase hover:bg-amber-600">
                    <Trans>Update Password</Trans>
                </button>
            </div>
        </form>;
    }

    stepFourForm() {
        return <div>
            <div class="w-full px-2 text-center pt-3 mb-2">
                <div class="bg-gray-200 border py-2 relative rounded text-base text-center text-green-600 w-full">
                    <div class="-top-1/3 absolute bg-green-600 border border-green-800 flex font-bold h-8 items-center justify-center left-2 rounded-full text-white text-xl w-8">!</div>
                    <span><Trans>Password updated with success!</Trans></span>
                </div>
            </div>
        </div>;
    }

    render({ onFinish }) {
        return <div class="flex flex-col gap-2">
            <div class="text-base uppercase w-full text-center py-2"><Trans>Password Recovery</Trans></div>
            <div class="w-full px-4 text-center">
                {!this.state.sending
                    ? !!this.state.error && <div class="w-full px-2 text-center pt-3 mb-2">
                        <div class="bg-gray-200 border py-2 relative rounded text-base text-center text-red-600 w-full">
                            <div class="-top-1/3 absolute bg-red-500 border border-red-600 flex font-bold h-8 items-center justify-center left-2 rounded-full text-white text-xl w-8">!</div>
                            <span>{window.Translation(this.errors[this.state.error])}</span>
                        </div>
                    </div>
                    : <div class="w-full px-2 text-center pt-3 mb-2">
                        <i class="fa text-2xl fa-spin fa-spinner" />
                    </div>}

                {this.state.step === 1 && this.stepOneForm()}
                {this.state.step === 2 && this.stepTwoForm()}
                {this.state.step === 3 && this.stepThreeForm()}
                {this.state.step === 4 && this.stepFourForm()}
            </div>
        </div>
    }
}